var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompModal',{ref:"comp_modal",attrs:{"title":_vm.isEdit ? '修改议题内容' : '发起议事',"width":"450px"}},[_c('CompForm',{attrs:{"forms":_vm.forms,"value":_vm.formdata},on:{"on-submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }